const scopes = new Set<symbol>();
export function enterMarketingReadOnly() {
  const scope = Symbol('admin-inspection');
  scopes.add(scope);
  return () => {
    scopes.delete(scope);
  };
}
export function assertMarketingWritable() {
  if (scopes.size) {
    throw new Error(
      'Admin inspection is read-only. Marketing decisions remain with Brandon and the assigned LO.'
    );
  }
}
